document.addEventListener('DOMContentLoaded', function () {
  const audioPlayers = document.querySelectorAll('[data-audio-player]');

function formatAudioTime(time) {
  if (!Number.isFinite(time) || time < 0) {
    return '0:00';
  }

  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60)
    .toString()
    .padStart(2, '0');

  return `${minutes}:${seconds}`;
}

audioPlayers.forEach(function (player) {
  const audio = player.querySelector('[data-audio]');
  const playPauseBtn = player.querySelector('[data-play-pause]');
  const progressBar = player.querySelector('[data-progress-bar]');
  const currentTimeEl = player.querySelector('[data-current-time]');
  const durationEl = player.querySelector('[data-duration]');
  const volumeIcon = player.querySelector(
  '[data-volume-icon], [data-volume-button]'
);

  if (
    !audio ||
    !playPauseBtn ||
    !progressBar ||
    !currentTimeEl ||
    !durationEl ||
    !volumeIcon
  ) {
    return;
  }

  function updatePlayButton() {
    if (audio.paused) {
      playPauseBtn.innerHTML = '&#9658;';
      playPauseBtn.setAttribute('aria-label', 'Play audio');
    } else {
      playPauseBtn.innerHTML = '&#10074;&#10074;';
      playPauseBtn.setAttribute('aria-label', 'Pause audio');
    }
  }

  function updateVolumeButton() {
    if (audio.muted || audio.volume === 0) {
      volumeIcon.innerHTML = '&#128263;';
      volumeIcon.setAttribute('aria-label', 'Unmute audio');
    } else {
      volumeIcon.innerHTML = '&#128266;';
      volumeIcon.setAttribute('aria-label', 'Mute audio');
    }
  }

  playPauseBtn.addEventListener('click', function () {
    if (audio.paused) {
      /*
       * A többi audio player leállítása.
       */
      audioPlayers.forEach(function (otherPlayer) {
        const otherAudio = otherPlayer.querySelector('[data-audio]');

        if (otherAudio && otherAudio !== audio) {
          otherAudio.pause();
        }
      });

      audio.play().catch(function (error) {
        console.error('Audio playback failed:', error);
      });
    } else {
      audio.pause();
    }
  });

  audio.addEventListener('loadedmetadata', function () {
    durationEl.textContent = formatAudioTime(audio.duration);
  });

  audio.addEventListener('durationchange', function () {
    durationEl.textContent = formatAudioTime(audio.duration);
  });

  audio.addEventListener('timeupdate', function () {
    currentTimeEl.textContent = formatAudioTime(audio.currentTime);
    durationEl.textContent = formatAudioTime(audio.duration);

    if (Number.isFinite(audio.duration) && audio.duration > 0) {
      progressBar.value = (audio.currentTime / audio.duration) * 100;
    } else {
      progressBar.value = 0;
    }
  });

  progressBar.addEventListener('input', function () {
    if (!Number.isFinite(audio.duration) || audio.duration <= 0) {
      return;
    }

    audio.currentTime =
      (Number(progressBar.value) / 100) * audio.duration;
  });

  volumeIcon.addEventListener('click', function () {
    audio.muted = !audio.muted;
  });

  audio.addEventListener('play', updatePlayButton);
  audio.addEventListener('pause', updatePlayButton);
  audio.addEventListener('volumechange', updateVolumeButton);

  audio.addEventListener('ended', function () {
    audio.currentTime = 0;
    progressBar.value = 0;
    currentTimeEl.textContent = '0:00';
    updatePlayButton();
  });

  updatePlayButton();
  updateVolumeButton();

  if (audio.readyState >= 1) {
    durationEl.textContent = formatAudioTime(audio.duration);
  }
});

 const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
      item.addEventListener('click', () => {
          item.classList.toggle('opened');
          item.classList.toggle('closed');
      });
  });


function tableOfContentsUl() {
  const tocList = document.querySelector('.CustomArticle--browse-categories-toc .sidebar-toc');
  if (!tocList) return;
  
  let currentOl = tocList;
  let headingStack = [];
  
  // Helper function to create a TOC entry and manage nested lists
  function createTocEntry(heading, currentOl, level) {
    // Exclude specific headings
    const excludedHeadings = ["Product Recommendations", "Related Articles"];
    if (excludedHeadings.includes(heading.textContent.trim())) {
      return currentOl; // Skip creating a TOC entry for these headings
    }
    
    // Create a unique ID if the heading doesn't have one
    if (!heading.id) {
      heading.id = heading.textContent.trim().toLowerCase().replace(/\s+/g, '-');
    }
  
    // Create a list item for the heading
    const listItem = document.createElement('li');
    listItem.innerHTML = `<a href="#${heading.id}">${heading.textContent}</a>`;
  
    // Adjust the nested list based on the heading level
    while (headingStack.length && headingStack[headingStack.length - 1] >= level) {
      headingStack.pop();
      currentOl = currentOl.parentElement.closest('ol') || tocList;
    }
  
    // Create a new <ol> if necessary and assign the appropriate class
    if (level > (headingStack[headingStack.length - 1] || 0)) {
      const newOl = document.createElement('ol');
  
      // Add a class based on the level to apply custom list styles
      if (level === 2) {
        newOl.classList.add('toc-level-2'); // Alphabetical list style
      } else if (level === 3) {
        newOl.classList.add('toc-level-3'); // Roman numeral list style
      }
  
      listItem.appendChild(newOl);
      currentOl.appendChild(listItem);
      currentOl = newOl;
    } else {
      currentOl.appendChild(listItem);
    }
  
    headingStack.push(level);
    return currentOl;
  }
  
  // Step 1: Process <section> elements with an order attribute
  const sections = Array.from(document.querySelectorAll('section[style*="order"]'));
  sections.sort((a, b) => parseInt(a.style.order || 0) - parseInt(b.style.order || 0));
   
  sections.forEach((section) => {
    const headings = section.querySelectorAll('h2, h3');
    headings.forEach((heading) => {
      const parentSection = heading.closest('section');
      let flag = true;
      const excludedHeadingsCheck = ["Product Recommendations", "Related Articles"];
      if(parentSection.querySelector('h2')) {
        const h2CheckText = parentSection.querySelector('h2').textContent;
        
        if(excludedHeadingsCheck.includes(h2CheckText.trim())) {
          flag = false;
        }        
      }
  
      const level = parseInt(heading.tagName.charAt(1));
      if(flag) {
        currentOl = createTocEntry(heading, currentOl, level);
      }
      
    });
  });

  
  const accordionHeader = document.querySelector('.CustomArticle--browse-categories-toc .accordion-header');
  const accordionContent = document.querySelector('.CustomArticle--browse-categories-toc .accordion-content');
  const accordionIcon = document.querySelector('.CustomArticle--browse-categories-toc .accordion-icon');
  if (accordionHeader && accordionContent) {
      accordionHeader.addEventListener('click', function () {
              accordionContent.classList.toggle('open');
              accordionHeader.classList.toggle('open');
          
      });
  }
}
  // Table of contents Ul
  tableOfContentsUl();


// Step 2: Process headings within the .CustomBlogTemplate-FooterContent element
/*
const footerContent = document.querySelector('.CustomBlogTemplate-FooterContent');
if (footerContent) {
  const footerHeadings = footerContent.querySelectorAll('h2, h3');
  footerHeadings.forEach((heading) => {
    const level = parseInt(heading.tagName.charAt(1));
    currentOl = createTocEntry(heading, currentOl, level);
  });
}
*/
 
 // Clone the template content and append it to the form
const formElement = document.getElementById('add-to-cart');
if (formElement) {
  const form = formElement.querySelector('form');
  const template = formElement.querySelector('template');
  if (form && template) {
    form.append(template.content.cloneNode(true));
  }
}
const formElementSide = document.getElementById('add-to-cart-top');
if (formElementSide) {
  const formSide = formElementSide.querySelector('form-side');
  const templateSide = formElementSide.querySelector('template');
  if (formSide && templateSide) {
    formSide.append(templateSide.content.cloneNode(true));
  }
}
// Function to handle the "Add to Cart" button click
function handleAddToCartClick() {
  // Add classes to the body element
  document.body.classList.add('sidebar-opened', 'sidebar-opened--right');

  // Add the class to the sidebar drawer element
  const sidebarDrawer = document.querySelector('sidebar-drawer#site-cart-sidebar');
  if (sidebarDrawer) {
    sidebarDrawer.style.display = 'grid';
    setTimeout(function(){
      sidebarDrawer.classList.add('sidebar--opened')
    },1300);
    
  }
}

// Event listener for the "Add to Cart" button
document.addEventListener('click', function(event) {
  // Check if the clicked element is the "Add to Cart" button
  if (event.target && event.target.closest('.add-to-cart-button')) {
    handleAddToCartClick();
  }
});

  const accordionHeader = document.querySelector('.accordion-header');
  const accordionContent = document.querySelector('.accordion-content');
  const accordionIcon = document.querySelector('.accordion-icon');
  if (accordionHeader && accordionContent) {
      accordionHeader.addEventListener('click', function () {
              accordionContent.classList.toggle('open');
              accordionHeader.classList.toggle('open');
          
      });
  }

   const supTags = document.querySelectorAll(".metafield-rich_text_field sup");

  supTags.forEach((sup) => {
    const prevNode = sup.previousSibling;

    if (prevNode && prevNode.nodeType === Node.TEXT_NODE) {
      console.log(prevNode);
      const words = prevNode.textContent.split(" ");
      const lastWord = words.pop();

      // Update the text node to exclude the last word
      prevNode.textContent = words.join(" ") + " ";

      // Create a span and append the last word and the <sup> tag
      const wrapper = document.createElement("span");
      wrapper.style.whiteSpace = "nowrap";
      wrapper.appendChild(document.createTextNode(lastWord));
      sup.innerHTML += " ";
      wrapper.appendChild(sup.cloneNode(true));

      // Replace the original <sup> with the wrapped version
      sup.parentNode.insertBefore(wrapper, sup);
      sup.remove();
    }
  });

    const seen = new Set();

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      const el = entry.target;
      const id = el.dataset.productId;

      // Only track if essential data is valid and not already seen
      if (
        !id ||
        seen.has(id) ||
        !el.dataset.productName ||
        isNaN(parseFloat(el.dataset.productPrice))
      ) {
        return;
      }

      // Push view_item to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          items: [{
            item_id: id,
            item_name: el.dataset.productName,
            price: parseFloat(el.dataset.productPrice),
            item_brand: el.dataset.productBrand || '',
            item_category: el.dataset.productCategory || ''
          }]
        }
      });

      seen.add(id); // Mark as seen

      // Unobserve all elements with the same product ID
      document.querySelectorAll(`.product-recommendation-container[data-product-id="${id}"]`).forEach(dupe => {
        observer.unobserve(dupe);
      });
    });
  }, {
    threshold: 0.25
  });

  // Observe all recommended product containers
  document.querySelectorAll(".product-recommendation-container").forEach(el => {
    observer.observe(el);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const recommendation = document.querySelector(
    '.V-ArticleMobileRecommendedProducts:not(.hide-mobilewidget)'
  );

  const headerContent = document.querySelector(
    '.CustomBlogTemplate-HeaderContent'
  );

  const articleContent = document.querySelector(
    '.CustomBlogTemplate--Content'
  );

  if (
    window.matchMedia('(max-width: 767px)').matches &&
    recommendation &&
    headerContent &&
    articleContent
  ) {
    // Mozgatás, hogy a teljes cikk alatt sticky tudjon maradni
    articleContent.insertBefore(recommendation, headerContent);

    // Sticky állapot figyelése
    const updateStickyState = () => {
      const rect = recommendation.getBoundingClientRect();
      const stickyTop = parseFloat(
        getComputedStyle(recommendation).top
      ) || 0;

      recommendation.classList.toggle(
        'sticked',
        rect.top <= stickyTop + 1
      );
    };

    window.addEventListener('scroll', updateStickyState, {
      passive: true
    });

    window.addEventListener('resize', updateStickyState);

    updateStickyState();
  }
});